import styled from 'styled-components';

const StyledPrice = styled.div`
  background-color: var(--grey200);
  width: 136px;

  > div:first-of-type {
    border: none;

    > div:first-of-type {
      margin-top: -8px;
    }
  }
`;

export default StyledPrice;
